export default __webpack_public_path__ + "static/user-manual_en-431c78b1d20ef5c1ba12c69ce708f616.pdf";